import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MenuSection from "../components/section/MenuSection";
import BannerSection from "../components/section/BannerSection";
import ShowOthersSection from "../components/section/ShowOthersSection";
import MyCouponsSection from "../components/section/MyCouponsSection";
import ShortsSection from "../components/section/ShortsSection";
import ChevronRight from "../components/icons/heroicons/solid/ChevronRight";
import LoadingBar from "./LoadingBar";

const clientsThis = async (headers) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/clients/this`,
      { headers }
    );
    return res.data?.data?.variables;
  } catch {
    return "";
  }
};

const Main = () => {
  const { t, i18n } = useTranslation();
  const [sections, setSections] = useState([]);

  // [loading, setLoading] = useState(false);
  const seniorLayout = localStorage.getItem("seniorLayout") === "true";

  // ใช้ state เพื่อ track loading แต่ละ section
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [menuLoaded, setMenuLoaded] = useState(false);
  const [showMoreLoaded, setShowMoreLoaded] = useState(false);

  const headers = useMemo(
    () => ({
      "X-Client-Auth": process.env.REACT_APP_CLIENT_AUTH,
      "Accept-Language": i18n.language.toUpperCase(),
    }),
    [i18n.language]
  );

  useEffect(() => {
    sessionStorage.setItem("previousPath", window.location.pathname);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pageId = await clientsThis(headers);

        const apiUrl = `${process.env.REACT_APP_API_URL}/api/pages/${pageId.root_page_id}`;
        const response = await axios.get(apiUrl, { headers });
        const result = response.data?.data?.sections || [];
        setSections(result);
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };

    fetchData();
  }, [i18n]);

  // ✅ loading = ถ้า section ไหนยังไม่โหลดเสร็จ
  const loading = !(bannerLoaded && menuLoaded && showMoreLoaded);

  return (
    <div className="flex flex-col items-center w-full bg-secondary-background-gray bg-gray-100">
      {/* Banner Section */}
      <BannerSection
        sections={sections}
        onLoaded={() => setBannerLoaded(true)}
      />

      {/* My Coupon */}
      {!loading && (
        <MyCouponsSection
          loading={loading}
          initialCouponType="B,M,P" // หรือ "P"
          initialCategoryKey="all" // "all" | "special_for_you" | "new_member"
          pageSize={10}
        />
      )}

      {/* Menu Section */}
      <div className="w-full">
        <MenuSection sections={sections} onLoaded={() => setMenuLoaded(true)} />
      </div>

      {/* Menu Shorts */}
      {/*<ShortsSection
        sections={sections}
        onLoaded={() => setShowMoreLoaded(true)}
      />*/}

      {/* Show More Section */}
      <div className="w-full mb-2">
        <ShowOthersSection
          sections={sections}
          onLoaded={() => setShowMoreLoaded(true)}
        />
      </div>

      {/* ✅ Loading Bar */}
      <LoadingBar loading={loading} label="Loading..." />
    </div>
  );
};

export default Main;
